import {useState, useMemo, useContext, useRef} from 'react'
import OrderlikeLayout from '../../../../../generic/Layouts/OrderlikeLayout'
import useDataFetcher from '../../knisot/hooks/useFetchData'
import { Recommendation } from '../../../../../modules/API/Recommendation/Recommendation'
import ControlSearchPannelLayout from '../../../../../generic/Layouts/Wrappers/ControlSearchPannelLayout'
import SearchInput from '../../../../../generic/inputs/inputSearch'
import CircleActiveFilterBtn from '../../../../../generic/particles/CircleActiveFilterBtn'
import PlusIcon from '../../../../../generic/icons/IconLib/PlusIcon'
import TitlesList from '../../../../../generic/titlesRowItem/TitlesList'
import RecomendationItem from './Components/RecomendationItem'
import { ContextModal } from '../../../../../modules/modal/modalContext'
import { Defaults } from '../../../../../modules/API/Defaults/defaults'
import { IProductsWithVarietyItem } from '../../../../../modules/API/Defaults/models/compliteProducts'
import ColumModal from '../../../../../generic/Layouts/ColumModal'
import CreateRecommendationProductModal from './Modals/CreateRecommendationProductModal'
import { IGrowerNodeGetResponse } from '../../../../../modules/API/Defaults/models/growers'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../../store/reducers/rootReducer'
import { IPostRecommendationProductFunctionProps } from './types/createRecommendationProductProps'
import { useNavigate, useLocation, useParams, useMatch } from 'react-router-dom'
import { LINKS } from '../../../../../Routs/config'
import { IProductListNodeResponse } from '../../../../../modules/API/Defaults/models/productListNode'
import GrowerProductMain from './Office/GrowerProductMain'
import { handleNotifications } from '../../../../../generic/utils/handleNotifications'

type Props = {}
//"Code_Dest_Suppl": 0, - growerID
//"Dest_Suppl": 1, - grower
const GrowerProductsMain = (props: Props) => {
  const user = useSelector((state: RootState) => state.mainReducer.user)
  const isOffice = user?.rights.includes('OFFICE')
  const matchModalRoute = useMatch(`${LINKS.forecasts.products.mainURL}/create`)
  const navigate = useNavigate()
  const [input, setInput] = useState<string>("")
  const [selectedGrower, setSelectedGrower] = useState<number>(Number(user?.code_internal) || 0)
  const {
    data: recommendedProducts,
    setData: setRecommendedProducts
  } = useDataFetcher(
    Recommendation.getRecommendationByGrowerID, `${selectedGrower}`
  )
  const {
    data: growerList,
    isLoading: growerListLoading
  } = useDataFetcher<IGrowerNodeGetResponse>(
    Defaults.getGrowerList, "data"
  )

  const {
    data: productsWithVariety,
  } = useDataFetcher<IProductsWithVarietyItem[]>(
    Defaults.getProductsWithVariety, 'data'
  )

  const {
    data: poductList,
  } = useDataFetcher<IProductListNodeResponse>(
    Defaults.getProductListNode, "1"
  )
  
  const handleControlModal = () => {
    if(matchModalRoute) return navigate(LINKS.forecasts.products.mainURL)
    navigate(`${LINKS.forecasts.products.mainURL}/create`)
  }

  const handleDelete = async (recID: number) => {
    try {
      if (!recommendedProducts) return
      const index = recommendedProducts.findIndex(item => item.RecID === recID)
      await Recommendation.deleteRecommendation(recommendedProducts[index].RecID)
      const newRecommendedProducts = recommendedProducts.filter((_, i) => i !== index)
      setRecommendedProducts(newRecommendedProducts)
      handleNotifications("הפריט נמחק בהצלחה", {type: "success"})
    } catch (error) {
      handleNotifications("הפריט לא נמחק", {type: "error"})
    }
  }

  const handleCreateRecommendation = async (data: IPostRecommendationProductFunctionProps) => {
    try {
      const postData = {
        Dest_Suppl: 1,
        ...data
      }
      const res = await Recommendation.createRecommendation(postData)
      setRecommendedProducts([...recommendedProducts || [], res])
      handleControlModal()
      handleNotifications("נוצר בהצלחה", {type: "success"})
    } catch (error: any) {
      if(error?.response?.status === 405) {
        handleNotifications("הפריט כבר קיים", {type: "error"})
      } else {
        handleNotifications("משהו השתבש", {type: "error"})
      }
    }
  }
  
  const recommendationModalProps = {
    productList: poductList?.products || [],
    growerList: growerList?.growers || [],
    handleCreateRecommendation: handleCreateRecommendation,
    user: user
  }

  const render = useMemo(() => {
    if(!recommendedProducts) return []
    return recommendedProducts.filter((item) => 
       `${item.ProductDesc?.trim()} ${item.VarietyDesc?.trim()}`.toLowerCase().includes(input.toLowerCase()) ||
        item.GrowerName?.trim().toLowerCase().includes(input.toLowerCase())
    )
  }, [input, recommendedProducts])


  return (
    <OrderlikeLayout
      label='פריטים לספק'
    >
      {
        !!matchModalRoute && !growerListLoading &&
        <ColumModal 
          Children={CreateRecommendationProductModal}
          childrenProps={recommendationModalProps}
          controlFunc={handleControlModal}
          title='הוספת פריט לספק'
        />
      }
     
      <GrowerProductMain 
        recommendedProducts={recommendedProducts || []}
        selectedGrower={selectedGrower}
        setSelectedGrower={setSelectedGrower}
        growerList={growerList?.growers || []}
        productWithVarietyList={productsWithVariety || []}
      />
  
    </OrderlikeLayout>
  )
}

export default GrowerProductsMain